import jQuery from '@modules/jquery';
import { gsap } from '@modules/gsap';
import { ScrollTrigger } from '@modules/gsap/ScrollTrigger';

// Registra il plugin ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

(function(jQuery) {
    jQuery(function($) {
    
        if ($(window).width() >= 1024) {
            //fai un if per controllare se il blocco è visibile
            if ($(".meetImgBackgroundBlock").is(":visible")) {
            // Crea una timeline per l'animazione
                var tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: "#sparkasse-meet-visual",
                        start: "top top+=110px", 
                        end: "+=100%", 
                        pin: true, 
                        scrub: true,
                        
                    }
                });
                
                // Aggiungi le animazioni alla timeline
                tl.fromTo(".image-animate--layer", {
                    x: -$(window).width()
                }, {
                    duration: 0.35,
                    x: 0,
                    ease: "power3.out"
                });
                
                tl.fromTo(".image-animate--phone", {
                    x: -$(window).width()
                }, {
                    duration: 0.25,
                    x: 0,
                    ease: "power2.out",
                    delay: -0.3
                });
             }
        }
    });
})(jQuery);